<script>
	import formBase from '@_system/components/base/form.vue'
	export default {
		extends: formBase,
		name: 'inventoryquantityadjustForm',
		props: {

		},
		data() {
			return {

			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			beforeInit(next){
				next()
			}
		},
		components: {

		}
	}
</script>
